import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {Heading, IMultiChoiceButtonOption, MultiChoice} from '@ruby-labs/ui-core-kit';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';

import { NextButton } from 'components/next-button';
import { FloatedButton } from 'components/floated-button';
import { getMultiChoiceSelected } from 'helpers/get-multichoice-button-select-options';

export const SpecificEvent = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageConfiguration } = useContext(BaseContext);

    const pageKey = LocalStorageKeys[RoutePath.SpecificEvent];

    const { pageValue, setPageValue } = useLocalStorage({
        key: pageKey,
        defaultValue: [],
    });

    const { pageValue: userAnswer, setPageValue: setUserAnswer } = useLocalStorage({
        key: `${pageKey}-other-userAnswer`,
        defaultValue: '',
    });

    const options: IMultiChoiceButtonOption[] = [
        {
            value: 'vacation',
            label: t('specific-event-option-vacation')
        },
        {
            value: 'wedding',
            label: t('specific-event-option-wedding')
        },
        {
            value: 'sporting-event',
            label: t('specific-event-option-sporting-event')
        },
        {
            value: 'beach-trip',
            label: t('specific-event-option-beach-trip')
        },
        {
            value: 'reunion',
            label: t('specific-event-option-reunion')
        },
        {
            value: 'other',
            label: t('specific-event-option-other'),
            placeholder: 'Add your answer here',
            userAnswer,
            setUserAnswer
        },
        {
            value: 'none',
            label: t('specific-event-option-no')
        }
    ];

    const handleClick = () => {
        const { values, labels } = getMultiChoiceSelected(pageValue);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('specific-event-title'), value: labels },
        });

        pageConfiguration.handleOnPageComplete({
            value: values,
            userAnswer: values.includes('other') ? userAnswer?.toString()?.trim() : ''
        });
    };

    return (
        <>
            <Heading title={t('specific-event-title')} />

            <MultiChoice
                options={options}
                disabledWhenValues={['none']}
                deselectWhenValues={['none']}
                selectedOptions={pageValue}
                onSelect={setPageValue} />

            <FloatedButton floated={pageValue.length} withGradient>
                <NextButton onClick={handleClick} disabled={!pageValue.length} />
            </FloatedButton>
        </>
    );
};
